export enum Sizing {
  FIT = 'fit',
}

export interface PreviewArchiveGraphQlRequest {
  scene_ids: string[];
  format: string;
  width: number;
  height: number;
  sizing?: Sizing;
  products: PreviewArchiveGraphQlRequestProduct[];
}

export interface PreviewArchiveGraphQlRequestProduct {
  product_uid: string;
  placeholders?: PreviewArchiveGraphQlRequestPlaceholder[];
}

export interface PreviewArchiveGraphQlRequestPlaceholder {
  name: string;
  url: string;
  product_uid: string;
}
